import React from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";
import { Button, DropDownButton } from 'devextreme-react';

export default function UserLoginCell(cellData) {

    var path = '/users/userDetails';

    if (cellData.data.userRoleId == 1) {
        path = '/users/clientDetails';
    }
    function onClick(e) {
        var tokenKey = "accessToken";
        var managerLogin = cellData.data.currentManagerLogin;
        var userData = {
            login: cellData.data.login,
            managerLogin: managerLogin,
            mode: e === "client" ? e : ""
        }
        fetch('api/account/adminToken', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify(userData)
            })
            .then(response => response.json())
            .then(data => {
                if (data.isSucceeded == true) {
                    if (e === "client") {
                        sessionStorage.setItem("saveToken", sessionStorage.getItem(tokenKey))
                    } else {
                        sessionStorage.setItem("managerLogin", managerLogin);
                    }
                    sessionStorage.setItem(tokenKey, data.data.accessToken);
                    sessionStorage.setItem("userName", data.data.fullName);
                    window.location.reload(false);
                    window.location.href = data.data.startLocation;
                }
                else {
                    this.setState({ loginMessage: data.message, checkCodeText: null });
                    this.hideCheckCode();
                }
            });
            
    }

    function onItemClick(e) {
        if (e.itemData.id == 1) {
            onClick()
        } else {
            onClick("client")
        }
    }

    const data = [
        {
            id: 1,
            name: "Войти как администратор",
        },
        {
            id: 2,
            name: "Войти как пользователь",
        },
    ]

    return (
        <div className="inCellButtonDiv">
            <DropDownButton
                className="inCellButton"
                id="custom-template"
                splitButton={true}
                useSelectMode={false}
                displayExpr="name"
                items={data}
                onButtonClick={onClick}
                onItemClick={onItemClick}
                type={'success'}
                text="Войти"
            />
        </div>
    );
}


// WEBPACK FOOTER //
// ./App/containers/users/userLoginCell.jsx